// Mock data for Tevaite Création Florale

export const siteInfo = {
  name: "Tevaite",
  subtitle: "Créations Florales",
  tagline: "L'art floral tropical au cœur de l'émotion",
  phone: "+689 89 29 29 30",
  email: "contact@tevaite-creation.com",
  instagram: "@tevaite_creation",
  locations: [
    { name: "Polynésie française", flag: "🇵🇫" },
    { name: "Paris", flag: "🇫🇷" },
    { name: "Oahu", flag: "🇺🇸" },
    { name: "Japon", flag: "🇯🇵" },
    { name: "Italie", flag: "🇮🇹" },
    { name: "Hilo Big Island", flag: "🌋" },
    { name: "Croatie", flag: "🇭🇷" }
  ]
};

export const heroImages = [
  "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/37vhol02_image.png",
  "https://images.unsplash.com/photo-1604545199306-23ee04a34dd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMGZsb3dlcnN8ZW58MHx8fHwxNzY5MzExOTEyfDA&ixlib=rb-4.1.0&q=85"
];

export const aboutContent = {
  title: "Notre Histoire",
  subtitle: "Une passion florale née au cœur du Pacifique",
  paragraphs: [
    "Tevaite Création est née d'une passion profonde pour l'art floral et la beauté tropicale de la Polynésie française. Chaque création est une œuvre unique, inspirée par les couleurs vibrantes et les parfums envoûtants des îles du Pacifique.",
    "Notre sensibilité artistique puise dans la richesse de la nature polynésienne, où chaque fleur raconte une histoire, où chaque composition évoque l'émotion pure. De Tahiti à Paris, de Oahu au Japon, nous apportons cette magie florale à travers le monde.",
    "Avec une dimension internationale, nous créons des moments inoubliables pour les mariages, événements et occasions spéciales, en respectant toujours l'harmonie entre l'art et la nature."
  ],
  image: "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/a5b4edxg_image.png"
};

export const creations = [
  {
    id: 1,
    title: "Robe Florale Tropicale",
    category: "evenements",
    image: "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/wo5zyw7z_image.png",
    description: "Création artistique unique en pétales de fleurs"
  },
  {
    id: 2,
    title: "Sculpture Océane",
    category: "bouquets",
    image: "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/uw1wyez7_image.png",
    description: "Art floral inspiré par les vagues du Pacifique"
  },
  {
    id: 3,
    title: "Composition Bora Bora",
    category: "mariages",
    image: "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/errv3hoq_image.png",
    description: "Élégance tropicale face au lagon"
  },
  {
    id: 4,
    title: "Décoration Événementielle",
    category: "evenements",
    image: "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/kw5a04e2_image.png",
    description: "Mise en scène florale pour réception"
  },
  {
    id: 5,
    title: "Installation Taapuna",
    category: "evenements",
    image: "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/ojzgjorw_image.png",
    description: "Création florale pour établissement haut de gamme"
  },
  {
    id: 6,
    title: "Bouquet Tropical",
    category: "bouquets",
    image: "https://images.unsplash.com/photo-1604545199306-23ee04a34dd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHx0cm9waWNhbCUyMGZsb3dlcnN8ZW58MHx8fHwxNzY5MzExOTEyfDA&ixlib=rb-4.1.0&q=85",
    description: "Composition vibrante aux couleurs du Pacifique"
  },
  {
    id: 7,
    title: "Orchidée Royale",
    category: "bouquets",
    image: "https://images.unsplash.com/photo-1512995738062-2d4ab94caf74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxleG90aWMlMjBmbG93ZXJzfGVufDB8fHx8MTc2OTMxMTkxN3ww&ixlib=rb-4.1.0&q=85",
    description: "Élégance pure et raffinée"
  },
  {
    id: 8,
    title: "Composition Tropicale",
    category: "bouquets",
    image: "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/ggzok07n_image.png",
    description: "Anthuriums et feuillages exotiques"
  }
];

export const services = [
  {
    id: 1,
    title: "Créations sur mesure",
    description: "Bouquets et compositions florales personnalisés selon vos envies et l'occasion. Chaque création est unique, pensée avec amour et attention aux détails.",
    icon: "Flower2"
  },
  {
    id: 2,
    title: "Décoration d'événements",
    description: "Transformez vos événements en jardins féeriques. Réceptions, galas, anniversaires... nous créons l'ambiance florale parfaite.",
    icon: "Sparkles"
  },
  {
    id: 3,
    title: "Mariages tropicaux",
    description: "Le jour de votre mariage mérite une touche d'exception. Bouquets de mariée, décoration de cérémonie, centres de table tropicaux.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Livraison internationale",
    description: "De la Polynésie au Japon, de Paris à Oahu, nous livrons nos créations à travers le monde pour vos proches.",
    icon: "Globe"
  }
];

export const instagramPosts = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/wo5zyw7z_image.png",
    likes: 456
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/errv3hoq_image.png",
    likes: 389
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/kw5a04e2_image.png",
    likes: 512
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_tevaite-creations/artifacts/ojzgjorw_image.png",
    likes: 278
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie-Claire L.",
    location: "Paris",
    text: "Les compositions de Tevaite ont sublimé notre mariage. Un vrai voyage au cœur des tropiques !",
    rating: 5
  },
  {
    id: 2,
    name: "Hinano T.",
    location: "Tahiti",
    text: "Une artiste exceptionnelle qui capture l'essence de notre culture polynésienne dans chaque création.",
    rating: 5
  },
  {
    id: 3,
    name: "Sarah K.",
    location: "Tokyo",
    text: "J'ai fait livrer un bouquet pour ma mère à Tahiti. Elle était émue aux larmes. Magnifique !",
    rating: 5
  }
];
